import { StepItemProps } from "@bsm/component";

export const useEmergencyContactStep = (): StepItemProps => {
    return {
        data: {
            title: "Emergency Contact",
            forms: [
                { type: "hidden", name: "id" },
                /* {
                    type: "checkbox",
                    name: "parents.parentType",
                    label: "Parent Type",
                    options: [
                        { label: "Is Dad ?", value: "DAD" },
                        { label: "Is Mom ?", value: "MOM" },
                        { label: "Is Step Dad ?", value: "STEP-DAD" },
                        { label: "Is Step Mom ?", value: "STEP-MOM" },
                        { label: "Is Assistant ?", value: "ASSISTANT" },
                    ],
                    required: true,
                }, */
                {
                    type: "input",
                    name: "lastName",
                    label: "Family Name",
                    required: true,
                },
                {
                    type: "input",
                    name: "firstName",
                    label: "First Name",
                    required: true,
                },
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone Number",
                    required: true,
                },
                /* {
                    type: "toggle",
                    name: "parents.isPreferredContact",
                    label: "Is preferred contact ?",
                },
                {
                    type: "toggle",
                    name: "parents.isRegisteringParent",
                    label: "Is registering parent ?",
                }, */
            ],
            next: {
                label: "Save",
            },
            hideBack: true,
            graphQL: {
                entity: "user",
            },
        },
    };
};
